module.exports = "<i class=\"ion-ios-circle-outline booking-state-icon\"\n   ng-if=\"::$ctrl.booking.isOpen()\"></i>\n\n<i class=\"ion-ios-checkmark booking-state-icon\"\n   ng-if=\"::($ctrl.booking.isFinished() && !$ctrl.booking.isCancelled())\"></i>\n\n<i class=\"ion-ios-close booking-state-icon\"\n   ng-if=\"::$ctrl.booking.isCancelled()\"></i>\n\n<span ng-if=\"::$ctrl.withLabel\" translate>\n    {{::$ctrl.booking.state}}\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/bookinst-state-icon/booking-state-icon.html
// module id = 874
// module chunks = 0